import { render, staticRenderFns } from "./Submitter.vue?vue&type=template&id=5c8bac11"
import script from "./Submitter.vue?vue&type=script&lang=js"
export * from "./Submitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports